require('./styles/app.less');

export const { VERSION } = process.env;
export { default as Player } from './ASVP';
export { PlayerEventType } from '@top/player-block-web'; // give events to projects that use this package

console.log('@adultswim/asvp.js', VERSION);
